import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { ChartOptions } from 'libs/portal/src/models/ChartOptions';
import { GraphChange } from 'libs/portal/src/models/GraphChange';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { NavigationService } from '@huge-monorepo/portal/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-generic-graph',
  templateUrl: './generic-graph.component.html',
  styleUrls: ['./generic-graph.component.scss'],
})
export class GenericGraphComponent implements OnInit {
  @ViewChild('chart', { static: false }) chart: ChartComponent;
  @Output() selected: EventEmitter<number> = new EventEmitter<number>();
  @Input() showDataLables = true;
  @Input() enableDataLabels = true;
  @Input() formatXAxisDate = true;
  @Input() colors: string[] = ['#FFA600', '#FF853D', '#FF6765', '#166ABE', '#7567C6', '#B25FBE', '#E256A9', '#FF5689'];
  public chartOptions: Partial<ChartOptions>;
  loading = false;
  graphLoaded = true;

  sidenavObservable: Subscription;
  isSideNavOpen: boolean;

  constructor(private detector: ChangeDetectorRef, private tools: ToolsService, private navigationService: NavigationService,) {}

  ngOnInit() {
    this.chartOptions = {
      series: [],
      chart: {
        type: 'line',
        height: 350,
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
        events: {
          mounted: (chart) => {
            chart.windowResizeHandler();
          },
          dataPointSelection: (event, chartContext, config) => {
            this.notifySelected(config.dataPointIndex);
            // this.selected.emit(config.dataPointIndex);
          },
        },
      },
      fill: {
        colors: this.colors,
        type: 'solid',
        opacity: 0.5,
      },
      colors: this.colors,
      stroke: {
        curve: 'smooth',
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        style: {
          colors: ['#000000'],
        },
        offsetY: -20,
      },
      title: {
        text: '',
        align: 'center',
      },
      markers: {
        size: this.enableDataLabels ? 1 : 0,
        hover: {
          sizeOffset: 4,
        },
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        type: 'category',
        categories: [],
        title: {
          text: '',
        },
        labels: {
          formatter: (value: any) => {
            if (this.formatXAxisDate) {
              let d = new Date(value);
              return this.tools.FormatDateTimeFromDateSwedish(d);
            }
            return value;
          },
        },
      },
      yaxis: {
        title: {
          text: '',
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -10,
        offsetX: -5,
      },
    };

    this.sidenavObservable = this.navigationService.GetSideNav((data) => {
      if (this.loading != true && this.isSideNavOpen != data) {
        this.isSideNavOpen = data;
        let temp = this.loading;
        this.loading = true;
        setTimeout(() => {
          this.loading = temp;
        });
      }
    });
  }

  public setGraphData(c: GraphChange) {
    let temp = this.chartOptions;
    this.chartOptions = null;
    this.detector.detectChanges();
    if (c.TickAmount != null) {
      temp.xaxis.tickAmount = c.TickAmount;
    }
    temp.title.text = c.Data.GraphTitle;
    if (c.Data.GraphType == 'stacked-bar') {
      temp.chart.type = 'bar';
      temp.chart.stacked = true;
    } else {
      temp.chart.type = c.Data.GraphType;
    }
    temp.xaxis.title.text = c.Data.XAxisLabel;
    temp.yaxis.title.text = c.Data.YAxisLabel;
    temp.xaxis.categories = c.Data.XAxisCategories;
    temp.xaxis.type = c.xAxisType ?? 'category';
    temp.series = c.Data.SeriesData;
    if (c.Data.GraphType == 'stacked-bar') {
      temp.chart.dropShadow.enabled = false;
      temp.fill.opacity = 1;
    }

    this.chartOptions = temp

    this.detector.detectChanges();
  }

  public setGraphLoading() {
    this.loading = true;
  }

  notifySelected(dataPointIndex) {
    if (this.selected != null) {
      this.selected.emit(dataPointIndex);
    }
  }
}
